import { callApi } from "../helpers/Api";
import { isTruthy } from "../utils/helpers";
import pages from "../subscriber/Pages";

export const getServices = () => {
    const functionUrl = `services`;
    const isBackground = true;
    const method = "GET";

    try {
        callApi({ functionUrl, method, isBackground }).then((response) => {
            const { status, result } = response || {};
            if(isTruthy(status)) {
                pages.updateValue("services", result);
            }
        });
    } catch (error) {
        console.error("API error: ", error);
        return false;
    }
};

export const getService = (slug) => {
    const functionUrl = `service`;
    const isBackground = true;
    const method = "GET";
    const urlValue = slug;

    try {
        return callApi({ functionUrl, method, isBackground, urlValue }).then((response) => {
            const { status, result } = response || {};
            if(isTruthy(status)) {
                return result;
            }
            return null;
        });
    } catch (error) {
        console.error("API error: ", error);
        return null;
    }
};

export const getProjects = () => {
    const functionUrl = `services`;
    const isBackground = true;
    const method = "GET";

    try {
        callApi({ functionUrl, method, isBackground }).then((response) => {
            const { status, result } = response || {};
            if(isTruthy(status)) {
                pages.updateValue("services", result);
            }
        });
    } catch (error) {
        console.error("API error: ", error);
        return false;
    }
};